/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@mui/styles';
import { makeStyles } from '@mui/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, Card, CardContent, Container, Divider } from '@mui/material';
import { Link } from 'react-router-dom'
import YtVideo from './ytVideo';


const styles = makeStyles(theme => ({
    root: {
    },
    cardContent: {
        margin: '20px'
    },
    imageDotedDescp: {
        transition: 'transform .2s',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        "&:hover": {
            transform: 'scale(1.2)',

        }
    },
    sectionTitleBorder: {
        width: '50px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',

    },
    divinfoNavigation: {
        marginTop: '100px'
    },
    blocksTypoInfo: {
        lineHeight: "2.5em!important"
    },
    blocksTypoInfoList:{
        padding:'0',
        color: theme.palette.primary.main

    }
}));


const Aboutus = () => {
    const classes = styles();

    return (
        <>

            <Grid container spacing={4}>

                <Grid item xs={12} sm={12} md={12}  >
                    <div >
                        <Typography variant="h1" align="center" style={{ color: "white", marginTop: '100px', marginBottom: '20px' }} paragraph>
                            About Us
                        </Typography>
                        <div className={classes.sectionTitleBorder}></div>
                        <div className={classes.divinfoNavigation}>

                            <Container className={classes.cardGrid} maxWidth="lg">
                                {/* End hero unit */}
                                <Grid container spacing={4}>
                                    <Grid item xs={12} sm={612} md={12}>
                                        <Card className={classes.cardService} >
                                            <CardContent className={classes.cardContent}>

                                                <img src="assets/images/Logo/logo.png" style={{ width: "200px", heignt: "200px" }} className='AlignCenter' />

                                                <Typography className={classes.blocksTypoInfo} variant="h3" align="center">
                                                    THERAYTEK's mission is to provide custom IT services
                                                    to help its customers grow and establish thier vision whatever their size,
                                                    and to overcome challenges of digital transformation
                                                    by having a whole vision and a strategic support.
                                                </Typography>
                                                <Typography className={classes.blocksTypoInfo} variant="h3" align="center">

                                                    We also partners with clients to align technology with business goals and
                                                    improve processes through suitable, innovative solutions.
                                                    In addition
                                                    THERAYTEK offers  custom application development, and business consulting services.

                                                </Typography>
                                                
                                            </CardContent>


                                        </Card>
                                    </Grid>


                                </Grid>
                            </Container>

                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12}  >
                    <div id="ytVideo" style={{ position: 'relative!important' }}>

                        <YtVideo />
                    </div>
                </Grid>

            </Grid>

        </>
    );
}

const mapStateToProps = () => {
    return {
        //   loginned: state.loginned
    }
}

const mapDispatchToProps = () => {
    return {

    }
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withStyles(styles)
)(Aboutus);